export var Intent = {
    NONE: 'none',
    PRIMARY: 'primary',
    NEGATIVE: 'negative',
    POSITIVE: 'positive',
    WARNING: 'warning'
};
